import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.rfp');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-rfp',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.rfp/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageRfpComponent implements OnInit {
    public tab: string = 'status';
    public loading: boolean = true;
    public pipelineStatus: any = {};
    public strategy: any = null;
    public rfpData: any = null;
    public sections: any[] = [];
    public selectedSection: any = null;
    public previewHtml: string = '';
    public pdfGenerating: boolean = false;
    public error: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadStatus();
    }

    public async setTab(tab: string) {
        this.tab = tab;
        this.error = '';
        if (tab === 'status') await this.loadStatus();
        if (tab === 'rfp') await this.loadRfp();
        if (tab === 'strategy') await this.loadStrategy();
        if (tab === 'sections') await this.loadStatus();
        if (tab === 'preview') await this.loadPreview();
        await this.service.render();
    }

    public async loadStatus() {
        this.loading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("status");
            if (code === 200) this.pipelineStatus = data;
        } catch (e) { }
        this.loading = false;
        await this.service.render();
    }

    public async loadRfp() {
        this.loading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("get_rfp");
            if (code === 200) this.rfpData = data.rfp;
            else this.error = data.message || 'RFP 데이터를 불러올 수 없습니다';
        } catch (e) {
            this.error = 'RFP 데이터를 불러올 수 없습니다';
        }
        this.loading = false;
        await this.service.render();
    }

    public async loadStrategy() {
        this.loading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("get_strategy");
            if (code === 200) this.strategy = data.strategy;
            else this.error = data.message || '전략 데이터를 불러올 수 없습니다';
        } catch (e) {
            this.error = '전략 데이터를 불러올 수 없습니다';
        }
        this.loading = false;
        await this.service.render();
    }

    public async loadSection(name: string) {
        this.loading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("get_section", { name });
            if (code === 200) this.selectedSection = { name, content: data.content };
            else this.error = data.message || '섹션을 불러올 수 없습니다';
        } catch (e) {
            this.error = '섹션을 불러올 수 없습니다';
        }
        this.loading = false;
        await this.service.render();
    }

    public async loadPreview() {
        this.loading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("get_final");
            if (code === 200) this.previewHtml = data.content;
            else this.error = data.message || '미리보기를 불러올 수 없습니다';
        } catch (e) {
            this.error = '미리보기를 불러올 수 없습니다';
        }
        this.loading = false;
        await this.service.render();
    }

    public async generatePdf() {
        this.pdfGenerating = true;
        this.error = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call("generate_pdf");
            if (code === 200) {
                await this.loadStatus();
            } else {
                this.error = data.message || 'PDF 생성에 실패했습니다';
            }
        } catch (e) {
            this.error = 'PDF 생성 중 오류가 발생했습니다';
        }
        this.pdfGenerating = false;
        await this.service.render();
    }

    public async downloadPdf() {
        window.open(`/wiz/api/page.rfp/download_pdf`, '_blank');
    }

    public getStepStatus(step: string): string {
        const s = this.pipelineStatus;
        if (!s) return 'pending';
        if (step === 'rfp') return s.has_structured_rfp ? 'done' : 'pending';
        if (step === 'strategy') return s.has_strategy ? 'done' : 'pending';
        if (step === 'sections') return (s.sections && s.sections.length > 0) ? 'done' : 'pending';
        if (step === 'final') return s.has_final_md ? 'done' : 'pending';
        if (step === 'pdf') return s.has_final_pdf ? 'done' : 'pending';
        return 'pending';
    }

    public openPreviewWindow() {
        window.open(`/wiz/api/page.rfp/preview`, '_blank');
    }
}

export default PageRfpComponent;